import { ReactNode } from "react";

interface InlineHighlightProps {
  children: ReactNode;
  color?: string;
  className?: string;
}

const InlineHighlight = ({ children, color = "navy", className = "" }: InlineHighlightProps) => {
  const colorClasses: Record<string, string> = {
    navy: "bg-brand-navy",
    red: "bg-brand-red",
    sky: "bg-brand-sky",
  };

  const bgColor = colorClasses[color] || colorClasses.navy;

  return (
    <span
      className={`${bgColor} text-white px-3 py-1 inline-block rounded-[0.25em] ${className}`}
      style={{
        boxDecorationBreak: 'clone',
        WebkitBoxDecorationBreak: 'clone'
      }}
    >
      {children}
    </span>
  );
};

export default InlineHighlight;
